export default "__VITE_ASSET__Di$CIpia__"